/* eslint-disable import/prefer-default-export */

export const DEFAULT_COLUMN_COUNT = 4;
